<template>
  <div class="card modal-card" v-if="ligneCommandeTemp && ligneCommandeTemp.lignesRemise">
    <div class="modal-card-body">
      <div class="card-content is-paddingless">
        <div class="mgb-50px">
          <h1 class="title is-size-3 has-text-centered">
            {{$t('editionRemise.title')}}
          </h1>
        </div>
      </div>
      <qd-message :title="$t('editionRemise.informations')"
                 type="is-info" v-if="getNombreLigneSasnsProduit() > 0">
        {{ $t('editionRemise.messageInformation', { nbLigne: getNombreLigneSasnsProduit() }) }}
      </qd-message>
      <div class="columns">
        <b-field :label="$t('editionRemise.applyOn')" class="column is-12">
          <qd-taginput
            v-model="typeSelected"
            :data="sortedType"
            autocomplete
            :allow-new="false"
            :open-on-focus="true"
            field="libelle"
            icon="label"
            type="is-primary"
            :disabled="ligneCommandeTemp.lignesRemise.length > 0"
            :placeholder="$t('editionRemise.selectProduct')"
            @typing="getFilteredTags"
            @input="getFormatageTagInput(lignesCommande)"
            @add="checkAddedType">
            <template slot-scope="props">
              <div class="dropdown-item  is-paddingless" v-if="!props.option.isSubTitle">
                <div class="columns is-marginless is-multiline">
                  <div class="column pdv-0">
                      <span class="has-text-weight-bold">
                        {{ props.option.libelle }}
                      </span>
                  </div>
                </div>
              </div>
              <div v-else class="dropdown-item is-disabled is-paddingless">
                {{ $t(props.option.title) }}
              </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <qd-collapse class="card-remise" :open="modeAAtteindreOpen">
        <div
          slot="trigger"
          slot-scope="props"
          class="card-header"
          role="button">
          <p class="card-header-title has-text-default">
            {{ $t('editionRemise.modeAAtteindre') }}
          </p>
          <a class="card-header-icon">
            <b-icon icon="chevron-right" class="animationChevron"
                    :class="{'rotationChevronOuvertureMenu': props.open }">
            </b-icon>
          </a>
        </div>
        <div class="card-content">
          <mode-a-atteindre :ligneCommandeTemp="ligneCommandeTemp"></mode-a-atteindre>
        </div>
      </qd-collapse>
      <qd-collapse class="card-remise mgt-20px">
        <div class="card-header">
          <p class="card-header-title has-text-default">
            {{ $t('editionRemise.modeManuel') }}
          </p>
        </div>
        <div class="card-content">
          <mode-manuel-remise-perso
              :cgvs="cgvs"
              :ligne-commande-temp="ligneCommandeTemp"
              :displayMontant="true"
              :disableCumuleMode="true"/>
        </div>
      </qd-collapse>
      <footer>
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$parent.close()">
            {{ $t('editionRemise.actions.revert')}}
          </button>
          <button
            class="button is-addOrEdit has-text-centered button-modal"
            @click="$emit('validationRemise', ligneCommandeTemp, typeSelected)" >
            {{ $t('editionRemise.actions.validate')}}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import modeManuelRemisePerso from '@/components/devisCommandeFacture/remise/modeManuelRemisePerso';
import modeAAtteindre from '@/components/devisCommandeFacture/remise/modeAAtteindre';
import sortLigneByType from '@/services/dcf/remise/remiseMultiProduit/sortLigneByTypeForTagInput';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import { NORMAL, REGROUPEMENT } from '@/configuration/devisConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    lignesCommande: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      ligneCommandeTemp: null,
      modeAAtteindreOpen: false,
      cgvs: [],
      filteredTags: [],
      typeSelected: [],
      sortedType: [],
      filteredLignesCommande: [],
    };
  },
  components: {
    modeManuelRemisePerso,
    modeAAtteindre,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
  },
  methods: {
    getNombreLigneSasnsProduit() {
      let nbLigne = 0;
      this.filteredLignesCommande.forEach((el) => {
        if (el.produitId === null) nbLigne += 1;
      });
      return nbLigne;
    },
    checkAddedType(newType) {
      if (newType.isSubTitle) {
        this.typeSelected.splice(this.typeSelected.length - 1, 1);
        return;
      }
      const oldTypeLigneSelected = [this.typeSelected[0]];
      if (oldTypeLigneSelected.length === 1 && oldTypeLigneSelected[0].produitId === null) {
        this.typeSelected = [];
        this.typeSelected.push(newType);
      }
      if (newType.produitId === null) this.typeSelected = [newType];
      this.getFormatageTagInput(this.filteredLignesCommande);
    },
    getPrice(lignesCommande, typeProduitSelected) {
      let total = 0;
      lignesCommande.forEach((ligne) => {
        if (!ligne.produitId) return;
        if (typeProduitSelected.find((el) => { return el.produitId === null; })) {
          total += ligne.totalAvantRemise;
          return;
        }
        const ligneMustBeInclude = typeProduitSelected
          .find((el) => { return el.produitId === ligne.produitId; });
        if (ligneMustBeInclude) {
          total += ligne.totalAvantRemise;
        }
      });
      return total;
    },
    getFormatageTagInput(lignesCommande) {
      this.sortedType = sortLigneByType(
        lignesCommande, this.typeSelected, this.ligneCommandeTemp,
      );
      this.ligneCommandeTemp.totalHt = this.getPrice(lignesCommande, this.typeSelected);
      this.ligneCommandeTemp.totalAvantRemise = this.getPrice(lignesCommande, this.typeSelected);
    },
    getFilteredTags(text) {
      this.getFormatageTagInput(this.lignesCommande.filter((option) => {
        if (!option.typeProduit) return false;
        return option.libelle
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      }));
    },
  },
  mounted() {
    if (this.modulePresseActive) {
      const lignesRegroupement = this.lignesCommande.filter(l => l.type === REGROUPEMENT);
      const produitTargetId = lignesRegroupement[0]?.produitId;
      if (produitTargetId && lignesRegroupement.every(lr => lr?.produitId === produitTargetId)) {
        this.cgvs = lignesRegroupement[0]?.produit?.cgvs;
      }
    }
    this.filteredLignesCommande = this.lignesCommande.filter(l => l.type === NORMAL);
    this.ligneCommandeTemp = {
      totalHt: 0,
      lignesRemise: [],
      totalAvantRemise: 0,
      remise: 0,
      listeMontant: [],
    };
    this.typeSelected.push({ produitId: null, libelle: this.$t('editionRemise.allProduct') });
    this.getFormatageTagInput(this.lignesCommande);
  },
};

</script>
